import React, { useEffect } from 'react';
import { PopoutMenu } from './PopoutMenu';
import { PopoutMenuFooter } from './PopoutMenuFooter';
import { PopoutMenuHeader } from './PopoutMenuHeader';

type Props = {
  isPopup: boolean;
  isOpen: boolean;
  isSubmitting?: boolean;
  position: 'left' | 'right';
  setTop?: boolean;
  noBackground?: boolean;
  noHeader?: boolean;
  noContentContainer?:  boolean;
  hdrTitle: string;
  primaryBtnTxt?: string;
  secondaryBtnTxt?: string;
  tertiaryBtnTxt?: string;
  givenClass?: string;
  noFooter?: boolean;
  primaryBtnColor?: string;
  secondaryBtnColor?: string;
  handleClose: any;
  handlePrimaryBtn?: any;
  handleSecondaryBtn?: any;
  handleTertiaryBtn?: any;
  width?: number;
  minWidth?: number;
  mobileMenu?: boolean;
  zIndexVal?: number;
  noOverflowToggle?: boolean;
  children?: any;
};

export const PopupOrPanel: React.FC<Props> = ({
  isPopup,
  isOpen,
  isSubmitting,
  position,
  setTop,
  noBackground,
  noHeader,
  noContentContainer,
  hdrTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  tertiaryBtnTxt,
  givenClass,
  noFooter,
  primaryBtnColor,
  secondaryBtnColor,
  handleClose,
  handlePrimaryBtn,
  handleSecondaryBtn,
  handleTertiaryBtn,
  width,
  minWidth,
  mobileMenu,
  zIndexVal,
  noOverflowToggle,
  children,
}) => {
  let handCLoseFunc = () => {
    document.body.style.overflowY = '';
    handleClose();
  };

  let primaryBtnFunc = () => {
    if(primaryBtnTxt && (primaryBtnTxt?.toLowerCase() === "close" || primaryBtnTxt?.toLowerCase() === "cancel")){
      document.body.style.overflowY = '';
    }

    handlePrimaryBtn();
  };

  let secondaryBtnFunc = () => {
    if(secondaryBtnTxt && (secondaryBtnTxt?.toLowerCase() === "close" || secondaryBtnTxt?.toLowerCase() === "cancel")){
      document.body.style.overflowY = '';
    }

    handleSecondaryBtn();
  };
  
  let tertiaryBtnFunc = () => {
    if(tertiaryBtnTxt && (tertiaryBtnTxt?.toLowerCase() === "close" || tertiaryBtnTxt?.toLowerCase() === "cancel")){
      document.body.style.overflowY = '';
    }

    handleTertiaryBtn();
  };  
  
  useEffect(() => {
    return () => {
      document.body.style.overflowY = '';
    };
  }, []);	  

  return (
    <PopoutMenu
      isPopup={isPopup}
      isOpen={isOpen}
      handleClose={handCLoseFunc}
      className={givenClass && givenClass}
      position={position}
      setTop={setTop}
      noBackground={noBackground}
      width={width}
      minWidth={minWidth}
      mobileMenu={mobileMenu}
      zIndexVal={zIndexVal}
      noOverflowToggle={noOverflowToggle}
    >
      {!noHeader &&
        <PopoutMenuHeader handleClose={handCLoseFunc} title={hdrTitle} />
      }

      {!noContentContainer ?
        <div className="PopoutMenuContent">{children}</div>
        :
        <>{children}</>
      }

      {!noFooter &&
        <PopoutMenuFooter
          primaryButtonText={primaryBtnTxt && primaryBtnTxt}
          secondaryButtonText={secondaryBtnTxt && secondaryBtnTxt}
          tertiaryButtonText={tertiaryBtnTxt && tertiaryBtnTxt}
          handlePrimaryButtonClick={handlePrimaryBtn && primaryBtnFunc}
          handleSecondaryButtonClick={handleSecondaryBtn && secondaryBtnFunc}
          handleTertiaryButtonClick={handleTertiaryBtn && tertiaryBtnFunc}
          primaryBtnColor={primaryBtnColor}
          secondaryBtnColor={secondaryBtnColor}
          isSubmitting={isSubmitting ?? false}
        />      
      }
    </PopoutMenu>
  );
};
